import {
	Switch,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	IconButton,
	Paper,
	Box,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export default function CouponTable({ data, onEdit, onDelete, onToggleStatus }: any) {
	return (
		<TableContainer component={Paper}>
			<Table size="small">
				<TableHead>
					<TableRow sx={{ fontFamily: 'Poppins' }}>
						<TableCell sx={{ fontFamily: 'Poppins' }}>Code</TableCell>
						<TableCell sx={{ fontFamily: 'Poppins' }}>Description</TableCell>
						<TableCell sx={{ fontFamily: 'Poppins' }}>Type</TableCell>
						<TableCell sx={{ fontFamily: 'Poppins' }}>Value</TableCell>
						<TableCell sx={{ fontFamily: 'Poppins' }}>Min Purchase</TableCell>
						<TableCell sx={{ fontFamily: 'Poppins' }}>Start</TableCell>
						<TableCell sx={{ fontFamily: 'Poppins' }}>End</TableCell>
						<TableCell sx={{ fontFamily: 'Poppins' }}>Status</TableCell>
						<TableCell align="right" sx={{ fontFamily: 'Poppins' }}>
							Actions
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{data.map((item: any) => (
						<TableRow key={item._id} sx={{ fontFamily: 'Poppins' }}>
							<TableCell sx={{ fontFamily: 'Poppins' }}>{item.code}</TableCell>
							<TableCell sx={{ fontFamily: 'Poppins' }}>{item.description}</TableCell>
							<TableCell sx={{ fontFamily: 'Poppins' }}>{item.type}</TableCell>
							<TableCell sx={{ fontFamily: 'Poppins' }}>{item.value}</TableCell>
							<TableCell sx={{ fontFamily: 'Poppins' }}>
								{item.minPurchaseAmount}
							</TableCell>
							<TableCell sx={{ fontFamily: 'Poppins', fontSize: '12px' }}>
								{item.startDate?.split('T')[0]}
							</TableCell>
							<TableCell sx={{ fontFamily: 'Poppins', fontSize: '12px' }}>
								{item.endDate?.split('T')[0]}
							</TableCell>
							<TableCell>
								<Switch
									checked={item.status === 1}
									onChange={() => onToggleStatus(item._id, item.status)}
								/>
							</TableCell>
							<TableCell align="right">
								<Box sx={{ display: 'flex' }}>
									<Box>
										<IconButton onClick={() => onEdit(item)}>
											<EditIcon />
										</IconButton>
									</Box>
									<Box>
										<IconButton onClick={() => onDelete(item._id)}>
											<DeleteIcon />
										</IconButton>
									</Box>
								</Box>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
		</TableContainer>
	);
}
